import { Dict } from '../models/interfaces';

export const getEnumValues = <U extends Dict, T = string>(en: U): T[] => {
  return Object.keys(en).map((key) => {
    return en[key] as T;
  });
};
